import { useEffect, useState } from 'react';
import { HERO_ROTATING_TAGLINES } from '@lighthouse/shared';

export function HeroRotatingTagline() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % HERO_ROTATING_TAGLINES.length);
    }, 4000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <p className="hero-rotating-tagline" aria-live="polite">
      <span key={index} className="hero-rotating-tagline-text">
        {HERO_ROTATING_TAGLINES[index]}
      </span>
    </p>
  );
}
